import classNames from 'classnames';
import { Pill } from '~/components/ui/nucleus/Pill';

type Props = {
  name?: string;
  value: string;
  label: string;
  toggle: string;
  count?: number;
  onChange: (value: string) => void;
};

/**
 * A filter toggle pill that displays an optional count badge.
 * Used for quick filters like Unread/Flagged that benefit from showing
 * how many items match the filter.
 */
export const CountFilterToggle = ({
  value,
  label,
  toggle,
  count,
  onChange,
}: Props) => {
  const checked = value !== '';
  const showCount = typeof count === 'number' && count > 0;

  return (
    <Pill as='label' type='filter' active={checked} className='gap-1.5'>
      <input
        type='checkbox'
        className='hidden'
        checked={checked}
        // If it is being toggled ON, return the toggle value
        // If it is being toggled OFF, return an empty string
        onChange={() => onChange(value ? '' : toggle)}
        aria-label={`${label}${showCount ? ` (${count})` : ''}`}
      />
      <span className='truncate'>{label}</span>
      {showCount && (
        <span
          className={classNames(
            'flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-xs font-medium tabular-nums',
            checked
              ? 'bg-primary-container text-white lg:bg-primary lg:text-white'
              : 'bg-grey-10 text-secondary lg:bg-grey-10 lg:text-secondary'
          )}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Pill>
  );
};
